import { createApp, h, onBeforeMount } from 'vue';
import { useStore } from '@components/common/store';
import { getParam } from '@services/url';
import { mountReplace } from '@/js/utils/mountUtils';
import SearchLandingPage from './SearchLandingPage.vue';

const mountPoint = document.getElementById('search-landing-page');

if (mountPoint) {
	const searchDataset = document.getElementById('search-form__header')?.dataset;
	const data = {
		phone: searchDataset?.phone,
		phoneLink: searchDataset?.phoneLink,
	};
	const isHotelOnly = getParam('ibe') === 'hotel';
	const store = useStore();

	const SearchLandingPageApp = createApp({
		name: 'SearchPage',
		setup() {
			store.commit('searchMask/updateFormData', { onlyHotel: isHotelOnly });

			onBeforeMount(() => {
				if (!store.state.config.storeInitialized) {
					store.dispatch('initStore', data);
				}
			});
		},
		data: () => (data),
		render: () => h(SearchLandingPage),
	});

	mountReplace(SearchLandingPageApp, mountPoint);
}
